// extracted by mini-css-extract-plugin
export default {"login-eula":"sLBQjsLS6VeyH8ecin2l"};